// extracted by mini-css-extract-plugin
export default {"expressCheckoutSection":"Yy-z","expressButtonContainerWithPayPal":"Zy-z","expressButton":"_y-z","or":"az-z"};